export default __webpack_public_path__ + "images/0x29219dd400f2bf60e5a23d13be72b486d4038894.png";